import React, {FC} from "react";

interface ProgressRingProps {
    apiData: any;
    size?: number;
    strokeWidth?: number;
}

const ProgressRing: FC<ProgressRingProps> = ({
                                                 apiData,
                                                 size = 35,
                                                 strokeWidth = 6,
                                             }) => {
    const score = apiData?.score_v2 ? parseFloat(apiData.score_v2) : 0;

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (score / 100) * circumference;

    return (
        <svg
            className="progress-ring me-2"
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
        >
            <circle
                className="progress-ring__background"
                stroke="#e0e0e0"
                strokeWidth={strokeWidth}
                fill="transparent"
                r={radius}
                cx={size / 2}
                cy={size / 2}
            />

            <circle
                className="progress-ring__progress"
                stroke="rgb(44, 175, 254)"
                strokeWidth={strokeWidth}
                fill="transparent"
                r={radius}
                cx={size / 2}
                cy={size / 2}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                style={{transition: "stroke-dashoffset 0.35s"}}
            />
        </svg>
    );
};

export default ProgressRing;
